import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CoreState, Jurisdiction, JurisdictionSelector } from "@obg/ngx.core";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { ignoreNil } from "@obg/rxjs";
import { map } from "rxjs/operators";

import { PLAYER_PROFILE } from "./select-player-profile.const";

@Component({
	selector: "obg-m-select-player-profile",
	templateUrl: "./select-player-profile.component.html",
	styleUrls: ["./select-player-profile.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SelectPlayerProfileComponent {
	@HostBinding("class.obg-m-select-player-profile") hostClass = true;

	@Input() playerProfile: string | undefined;
	@Input() @coerceBoolean() radioGroupDisabled = false;
	@Output() playerProfileChange = new EventEmitter<string>();

	allProducts = PLAYER_PROFILE.allProducts;
	sportsbookOnly = PLAYER_PROFILE.sportsbookOnly;
	casinoOnly = PLAYER_PROFILE.casinoOnly;

	isJurisdictionSga$ = this.store.pipe(
		select(JurisdictionSelector.get),
		ignoreNil(),
		map((jurisdiction) => jurisdiction === Jurisdiction.Sga)
	);

	constructor(private store: Store<CoreState>) {}
}
